<template>
  <div class="mod-order-execution">
    <el-form :inline="true" :model="query" @keyup.enter.native="pageIndex = 1; loadData()">
      <el-form-item label="采购订单"><el-input v-model="query.orderCode" size="small" clearable style="width:130px" /></el-form-item>
      <el-form-item label="供应商"><el-input v-model="query.partnerName" size="small" clearable style="width:130px" /></el-form-item>
      <el-form-item label="物料编码"><el-input v-model="query.materialCode" size="small" clearable style="width:110px" /></el-form-item>
      <el-form-item label="执行状态">
        <el-select v-model="query.executionFilter" size="small" style="width:130px">
          <el-option label="全部待办" value="all_open" />
          <el-option label="已订未入" value="open_stock" />
          <el-option label="已入未结" value="open_finance" />
          <el-option label="已退可结" value="open_return_settle" />
          <el-option label="全部" value="all" />
        </el-select>
      </el-form-item>
      <el-form-item label="订单日期">
        <el-date-picker v-model="query.orderDateStart" type="date" value-format="yyyy-MM-dd" size="small" style="width:130px" placeholder="起" />
        <span style="margin:0 4px">-</span>
        <el-date-picker v-model="query.orderDateEnd" type="date" value-format="yyyy-MM-dd" size="small" style="width:130px" placeholder="止" />
      </el-form-item>
      <el-form-item><el-button type="primary" size="small" @click="pageIndex = 1; loadData()">查询</el-button></el-form-item>
    </el-form>
    <el-table :data="dataList" border v-loading="loading" show-summary :summary-method="getSummaries" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
      <el-table-column type="index" label="序号" width="55" align="center" fixed="left" />
      <el-table-column prop="orderCode" label="采购订单" width="120" fixed="left" />
      <el-table-column prop="orderDate" label="订单日期" width="105" align="center">
        <template slot-scope="scope">{{ (scope.row.orderDate || '').slice(0, 10) }}</template>
      </el-table-column>
      <el-table-column prop="partnerName" label="供应商" min-width="120" />
      <el-table-column prop="materialCode" label="物料编码" width="110" />
      <el-table-column prop="materialName" label="物料名称" min-width="120" />
      <el-table-column prop="orderQuantity" label="订单量" width="90" align="right" />
      <el-table-column prop="arrivedQuantity" label="已到货" width="90" align="right" />
      <el-table-column prop="remainArrivalNoticeQuantity" label="可到货" width="90" align="right">
        <template slot-scope="scope"><span :class="{ 'text-warn': Number(scope.row.remainArrivalNoticeQuantity) > 0 }">{{ scope.row.remainArrivalNoticeQuantity }}</span></template>
      </el-table-column>
      <el-table-column prop="inspectedQuantity" label="已检验" width="90" align="right" />
      <el-table-column prop="remainIncomingInspectionQuantity" label="可送检" width="90" align="right">
        <template slot-scope="scope"><span :class="{ 'text-warn': Number(scope.row.remainIncomingInspectionQuantity) > 0 }">{{ scope.row.remainIncomingInspectionQuantity }}</span></template>
      </el-table-column>
      <el-table-column prop="fulfilledQuantity" label="已入库" width="90" align="right" />
      <el-table-column prop="returnedQuantity" label="已退货" width="90" align="right" />
      <el-table-column prop="pendingStockQuantity" label="待审入库" width="90" align="right" />
      <el-table-column prop="remainStockQuantity" label="可入库" width="100" align="right">
        <template slot-scope="scope"><span :class="{ 'text-warn': Number(scope.row.remainStockQuantity) > 0 }">{{ scope.row.remainStockQuantity }}</span></template>
      </el-table-column>
      <el-table-column prop="postedFinanceQuantity" label="已挂账" width="90" align="right" />
      <el-table-column prop="remainFinanceQuantity" label="可挂账" width="100" align="right">
        <template slot-scope="scope"><span :class="{ 'text-warn': Number(scope.row.remainFinanceQuantity) > 0 }">{{ scope.row.remainFinanceQuantity }}</span></template>
      </el-table-column>
      <el-table-column prop="remainSettleAmount" label="未付款" width="110" align="right" />
      <el-table-column prop="remainReturnSettleQuantity" label="退结余量" width="90" align="right">
        <template slot-scope="scope"><span :class="{ 'text-warn': Number(scope.row.remainReturnSettleQuantity) > 0 }">{{ scope.row.remainReturnSettleQuantity }}</span></template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="70" align="center">
        <template slot-scope="scope"><el-button type="text" size="small" @click="openTrace(scope.row)">追溯</el-button></template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="val => { pageSize = val; pageIndex = 1; loadData() }"
      @current-change="val => { pageIndex = val; loadData() }"
      :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper" style="margin-top:12px"
    />
    <purchase-order-trace-dialog :visible.sync="traceVisible" :order-line-id="traceOrderLineId" />
  </div>
</template>

<script>
import PurchaseOrderTraceDialog from '../../components/purchase-order-trace-dialog/index.vue'
import request from '../../api/request'

export default {
  name: 'PurchaseOrderExecution',
  components: { PurchaseOrderTraceDialog },
  data() {
    return {
      query: { orderCode: '', partnerName: '', materialCode: '', executionFilter: 'all_open', orderDateStart: '', orderDateEnd: '' },
      dataList: [], loading: false, pageIndex: 1, pageSize: 20, totalPage: 0, traceVisible: false, traceOrderLineId: ''
    }
  },
  created() { this.loadData() },
  activated() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      request.post('/purchase/purchaseOrderExecution/list', {
        currentPage: this.pageIndex, pageSize: this.pageSize,
        code: this.query.orderCode, partnerName: this.query.partnerName,
        materialCode: this.query.materialCode, executionFilter: this.query.executionFilter,
        dateFrom: this.query.orderDateStart, dateTo: this.query.orderDateEnd
      }).then(res => {
        const body = res.data || {}
        this.dataList = (body.list || []).map(row => ({
          orderLineId: row.purchaseOrderLineId,
          orderCode: row.purchaseOrderCode,
          orderDate: row.orderDate,
          partnerName: row.supplierName,
          materialCode: row.materialCode,
          materialName: row.materialName,
          orderQuantity: row.quantity,
          arrivedQuantity: row.arrivedQuantity,
          remainArrivalNoticeQuantity: row.remainArrivalNoticeQuantity,
          inspectedQuantity: row.inspectedQuantity,
          remainIncomingInspectionQuantity: row.remainIncomingInspectionQuantity,
          fulfilledQuantity: row.receivedQuantity,
          returnedQuantity: row.returnedQuantity,
          pendingStockQuantity: row.pendingStockInQuantity,
          remainStockQuantity: row.remainStockQuantity,
          postedFinanceQuantity: row.payablePostedQuantity,
          remainFinanceQuantity: row.remainPayableQuantity,
          remainSettleAmount: row.remainPaymentAmount,
          remainReturnSettleQuantity: row.remainReturnSettleQuantity
        }))
        this.totalPage = body.totalCount || 0
      }).catch(err => {
        this.dataList = []
        this.totalPage = 0
        this.$message.error((err && err.message) || '加载采购执行看板失败')
      }).finally(() => { this.loading = false })
    },
    openTrace(row) {
      if (!row.orderLineId) return
      this.traceOrderLineId = row.orderLineId
      this.traceVisible = true
    },
    getSummaries({ columns, data }) {
      const sums = []
      const sumFields = ['orderQuantity', 'arrivedQuantity', 'remainArrivalNoticeQuantity', 'inspectedQuantity', 'remainIncomingInspectionQuantity', 'fulfilledQuantity', 'returnedQuantity', 'remainStockQuantity', 'remainFinanceQuantity', 'remainSettleAmount']
      columns.forEach((col, index) => {
        if (index === 0) { sums[index] = '合计'; return }
        if (sumFields.indexOf(col.property) < 0) { sums[index] = ''; return }
        const total = data.reduce((s, r) => s + Number(r[col.property] || 0), 0)
        sums[index] = total.toFixed(3)
      })
      return sums
    }
  }
}
</script>

<style scoped>
.text-warn { color: #e6a23c; font-weight: 600; }
</style>
